let panel = $('#data-side-panel-create-task');

panel.on('nc.sidePanel.shown', function (e, sidePanel) {
    initCreateTaskForm(sidePanel);
});

function initCreateTaskForm(sidePanel) {
    let form = sidePanel.find('#create-task-form')
    let typeFormContainer = form.find('#task-type-create-addition');
    let typeSelect = form.find('select[name=task_type_id]');
    let currentType = typeSelect.val();

    typeSelect.change(function () {
        currentType = this.value;

        if (isNaN(parseInt(this.value))) {
            return;
        }
        $.ajax({
            url: form.data('route-type-view').replace(/\/\d+/, '/' + this.value),
            method: 'GET',
            success: function (result) {
                typeFormContainer.html(result);
                typeFormContainer.find('[id^=data-side-panel-]').each(function (k, i) {
                    $(i).detach().appendTo(sidePanel.childPanels);
                    sidePanels.init(i);
                });
            }
        })
    })
}
